import * as React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {Box,Typography,Button,Snackbar} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import AutoInput from './AutoInput';
import axios from 'axios'
import {IconButton} from "@mui/material"
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import {useSelector, useDispatch} from 'react-redux';
import {useTheme,styled} from '@mui/material/styles'
import { AccountCircle,ArrowCircleRightOutlined,ArrowDropDownOutlined, FilePresentRounded,FormatAlignCenter, Filter9Outlined,CheckCircleOutline } from '@mui/icons-material';
import EditorText from "./EditorText"


const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
	borderRadius:10,
	background:"black",
	margin:5
}));

const AccordionSummary = styled((props) => (
<MuiAccordionSummary
	expandIcon={<ArrowDropDownOutlined sx={{ fontSize: 30 }} />}
	{...props}
/>
))(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black': 'white',
	flexDirection: 'row',
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
		marginBottom: theme.spacing(1)
	}
}));
	
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	background:theme.palette.mode === 'dark'? 'black' : 'white'
}));

const SectionGeneratedAdd = ({visible,setVisible,handleGeneratedAdd,level,lang,section_content,total_questions})=>{

const theme = useTheme()
const dispatch = useDispatch()
const [response_type, setResponse_type] = React.useState("selection");
const [question, setQuestion] = React.useState("");
const [responses, setResponses] = React.useState([]);
const [possResponses, setPossResponses] = React.useState([]);
const [open, setOpen] = React.useState(false);
const [expanded, setExpanded] = React.useState(true);
const [generating, setGenerating] = React.useState(false);
const user = useSelector(state => state?.auth.user);
const [message, setMessage] = React.useState("");
const [isQuestionGenerated, setIsQuestionGenerated] = React.useState(false);
const [isResponseGenerated, setIsResponseGenerated] = React.useState(false);
const [question_desc, setQuestion_desc] = React.useState("");
const response_types= ["selection","True & False"]

const onClose = () => {
	setVisible(false);
};

const handleChange = () => (event, newExpanded) => {
	setExpanded(newExpanded ? true : false);
};

async function generate_question(category) {
	try{

		if (question_desc !== "" && lang !== "") {
			
			const data = {
				description:question_desc,
				level:level,
				lang:lang,
				type:response_type === "selection" ? "multiple" : response_type
			}

			setGenerating(true)

			const generate = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}generate-question`,data,{
				 headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${user?.accessToken}`
              }
			}).catch(err=>{
				setMessage("connection error")
				setOpen(true)
				setGenerating(false)
			})

			if (generate?.status == 200 && generate?.data.success) {
				setIsQuestionGenerated(true)
				setQuestion(generate?.data?.response?.question)
				setPossResponses(generate?.data?.response?.correct_responses)
				setResponses(generate?.data?.response?.responses)

				// window.scrollTo({
				// 	top: 0,
				// 	behavior: 'smooth'
				// });

			} else {
				setMessage(generate?.data?.message)
				setOpen(true)
			}
			setGenerating(false)
		} else {
			setOpen(true)
			setMessage("please,add a description and the language")
		}

	}catch(error){
		console.log(error)
	}
}


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<MenuIcon/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Section question generation
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{justifyContent:"center",background:theme.palette.background.default,overflowY: "auto",overflowX: 'hidden',}}>
			<Snackbar 
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}} 
				message={message} 
				onClose={()=>{setOpen(false)}} 
				open={open} 
				autoHideDuration={2000}
			/>
			<Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between" m={1} alignItems="flex-start" sx={{width:"100%"}}>
				<AutoInput
					data={response_types}
					setInput={setResponse_type}
					input={response_type}
					label="response type"
				/>
				<Box width="95%">
					<EditorText
						data={question_desc}
						setData={setQuestion_desc}
						width="95%"
						label="Question"
						isRequired={true}
					/>
				</Box>
				<Box disabled={generating} mt={1} display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between" alignItems="flex-start" sx={{width:"90%"}}>
					<Button onClick={(e)=>{
						e?.preventDefault()
						// setIsQuestionGenerated(prev=>!prev)
						generate_question()
					}} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:10,marginBottom:1}} variant="contained">
						{
							generating ? <CircularProgress size={15} sx={{color:"#000"}}/> : "Generate"
						}
					</Button>
					{
						isQuestionGenerated && (
							<CheckCircleOutline color="gold"/>
						)
					}
				</Box>
				{
					isQuestionGenerated && (
						<Box sx={{width:"95%",justifyContent:"center",alignItems:"center",marginBottom:2}}>
							<Accordion sx={{width:"100%",marginLeft:1}} expanded={expanded} onChange={handleChange(true)}>
								<AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
									<Typography ml={2} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans"}}>
										Question / responses
									</Typography>
								</AccordionSummary>
								<AccordionDetails sx={{justifyContent:"center",alignItems:"center",ml:2,textAlign:"left"}}>
									<Typography mb={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans"}}>
										Question
									</Typography>
									<Typography mt={2} ml={2} style={{fontSize:12,fontWeight:400,whiteSpace:"pre-wrap"}}>
										{question}
									</Typography>
									<Typography mb={1} mt={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans"}}>
										Possible Responses
									</Typography>
									<Typography mt={2} ml={2} style={{fontSize:12,fontWeight:400,whiteSpace:"pre-wrap"}}>
										<ol>
											{
												responses?.map((item,index)=>(
													<li key={index} style={{margin:5}}>
														{item}
													</li>
												))
											}
										</ol>
									</Typography>
									<Typography mb={1} mt={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans"}}>
										Exact Responses
									</Typography>
									<Typography mt={2} ml={2} style={{fontSize:12,fontWeight:400,whiteSpace:"pre-wrap"}}>
										<ol>
											{
												possResponses?.map((item,index)=>(
													<li key={index} style={{margin:5}}>
														{item}
													</li>
												))
											}
										</ol>
									</Typography>
								</AccordionDetails>
							</Accordion>
						</Box>
					)
				}
			</Box>
			<Box width="100%" alignItems="flex-start" justifyContent="flex-start">
				<Button onClick={(e)=>{
					e?.preventDefault()
					if(question !== "" && responses.length > 0){
						if (total_questions > section_content?.length) {
							const data = {
								question:question,
								responses:responses,
								correct_responses:possResponses,
								question_type:response_type,
								hasAudio:false,
								hasVideo:false,
								hasImage:false,
								isGenerated:true,
								audioUrl:"https://",
								videoUrl:"https://",
								imageUrl:"https://"
							}

							setIsQuestionGenerated(false)

							setQuestion("")
							setResponses([])
							setPossResponses([])


							handleGeneratedAdd(data)
						} else {
							setMessage(`you have to give only less than or equal of ${total_questions} questions`)
							setOpen(true)
						}

					}else{
						setMessage(`you have to add a question or give a response to add this question`)
						setOpen(true)
					}
				}} disabled={!isQuestionGenerated} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:10,marginLeft:1,marginBottom:3}} variant="contained">
					Add question
				</Button> 
			</Box>
		</DialogContent>
	</Dialog>
	)
}

export default SectionGeneratedAdd